import { memo } from "react";

import { AddToCartButton } from "@components/Button/AddToCartButton.data";
import { VariantSelectorManager } from "@components/VariantSelector/VariantSelectorManager.data";
import { Klarna } from "@react/sections/ProductHero/Klarna";
import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import {
  type OPProduct,
  type ProductHeroSettings,
  type OPProductVariant,
} from "@tablescape/state";
import { tw } from "classnames";

type Props = {
  formatBtnText: {
    available: string;
    soldOut: string;
    waitlisted: string;
  };
  product: OPProduct;
  selectedVariant: OPProductVariant;
  setSelectedVariant: (variantId: OPProductVariant["id"]) => void;
};

const style = {
  klarna: tw("mt-2", "mg:mt-4", "h-9"),
  addToCartButton: tw("mt-8", "mg:mt-10"),
};

const ProductFormViewBase = ({
  formatBtnText,
  product,
  selectedVariant,
  setSelectedVariant,
}: Props) => {
  const {
    meta: {
      localization: { country, language },
    },
    settings: { intelligemsEnabled, klarnaEnabled, theme },
  } = useSectionSettings<ProductHeroSettings>();

  return (
    <>
      <VariantSelectorManager
        activeProduct={product}
        context="productForm"
        displayUnavailableVariants
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
      />
      <div className={style.addToCartButton}>
        <AddToCartButton
          formatBtnText={formatBtnText}
          isIntelligemsEnabled={intelligemsEnabled}
          products={[product]}
          theme={theme}
          variants={[selectedVariant]}
        />
      </div>
      {klarnaEnabled && (
        <div className={style.klarna}>
          <Klarna
            country={country}
            language={language}
            price={selectedVariant.price}
            theme={theme}
          />
        </div>
      )}
    </>
  );
};

export const ProductFormView = memo(ProductFormViewBase);
